import React from "react";
import UserInviteModalState, { UserInviteModalProps } from "./UserInviteModal.models";
import './UserInviteModal.scss';
import { Modal } from "react-bootstrap";
import QrCodeGenerator from "../../shared/qr-code-generator/QrCodeGenerator";

export default class UserInviteModal extends React.PureComponent<UserInviteModalProps, UserInviteModalState>{

    constructor(props: any) {
        super(props);
        this.state = { keyGenerator: '' };
    }

    componentDidMount() {
        this.setState({ keyGenerator: this.props.keyGenerator });
    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.keyGenerator !== this.props.keyGenerator)
            this.setState({ keyGenerator: this.props.keyGenerator });
    }

    render(): React.ReactNode {
        let { closeModal, showModal } = this.props;
        let { keyGenerator } = this.state;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>دعوت از دوستان</label>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ textAlign: "center" }} className="pt-2 pb-2">
                        <label className="text-muted col-12">کد QR زیر را اسکن کنید</label>
                        <QrCodeGenerator keyGenerator={keyGenerator} />
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-outline-danger tk-float-left" onClick={closeModal}>انصراف</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}